import styled from 'styled-components'

import { COLOR, FONT_SIZE, NATIVE_BASE_COLORS} from '../../../../../themes'

const Style = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 32px 56px 24px;
  overflow-x: hidden;
  overflow-y: auto;

  .issue-item {
    padding: 24px 0px 27px 0px;
    border-bottom: 1px solid ${NATIVE_BASE_COLORS.MUTED[200]};
  }
  
  .issue-item-header-layout {
    display: flex;
    flex-direction: column;
  }

  .issue-item-header-status {
    display: flex;
    align-items: center;
  }

  .issue-item-header {
    font-family: NunitoSansSemiBold;
    font-size: ${FONT_SIZE.SM};
    color: ${NATIVE_BASE_COLORS.TEXT[900]};
    margin-right: 8px;
  }

  .issue-item-date {
    font-family: NunitoSansSemiBold;
    font-size: ${FONT_SIZE.TN};
    color: ${NATIVE_BASE_COLORS.TEXT[500]};
    padding: 8px 0px;
  }

  .issue-orders-item {
    font-family: NunitoSansBold;
    font-size: ${FONT_SIZE.XXS};
    color: ${NATIVE_BASE_COLORS.TEXT[900]};
    padding: 8px 0px;
  }

  .issue-description {
    width: 100%;
    max-height: 100px;
    font-family: NunitoSansRegular;
    font-size: ${FONT_SIZE.XXS};
    color: ${NATIVE_BASE_COLORS.TEXT[900]};
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .issue-images {
    padding-top: 16px;
    display: flex;
    overflow-y: hidden;
    overflow-x: auto;
  }

  .bg-image {
    width: 96px;
    height: 96px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${COLOR.BLACK};

    &:not(:first-child) {
      margin-left: 8px;
    }
  }

  .issue-image-item {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  .issue-not-found {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: NunitoSansSemiBold;
    font-size: ${FONT_SIZE.XXS};
    color: ${NATIVE_BASE_COLORS.TEXT[400]};
  }
`

export default Style
